import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { analytics } from 'firebase';
import { EpaycoService } from '../../../_services/epayco.service';

@Component({
  selector: 'app-epayco-response',
  templateUrl: './epayco-response.component.html',
  styleUrls: ['./epayco-response.component.scss']
})
export class EpaycoResponseComponent implements OnInit {

  refPayco: string = ''
	transactionResponse:any ;
  constructor(private epaycoService: EpaycoService, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
         this.refPayco= params['ref_payco'] || params['x_ref_payco'];
     });
      this.epaycoService.getTransactionResponse(this.refPayco)
      .subscribe((data: any) =>{
          this.transactionResponse = data.data;
          console.log(data);
          
          // localStorage.removeItem('listProductsSession');
          // this._cartCounterService.setNumber(0);
  
      });
    }

}
